import { makeAutoObservable } from 'mobx';
import { ProgramType } from '../api/types/programs/program.type';
import { ProgramDetails } from '../api/types/programs/program-details';
import { ProgramMetadata } from '../api/types/programs/program-metadata';
import { CourseStatus } from '../api/types/programs/course/course-status';
import globalCourseStore from './global-course-store';

class ProgramStore {
  private _version = 0;
  private _programs: Map<number, ProgramType> = new Map<number, ProgramType>();
  private _currentId?: number;
  constructor() {
    makeAutoObservable(this, {}, { deep: true }); // Just add deep: true
  }

  getCurrentId(): number | undefined {
    return this._currentId;
  }

  set currentId(value: number) {
    this._currentId = value;
  }

  addProgram(program: ProgramType) {
    this._programs.set(program.metadata.id, program);
  }

  addPrograms(programs: ProgramType[]) {
    for (const programItem of programs) {
      this.addProgram(programItem);
    }
  }

  addProgramMetadata(metadata: ProgramMetadata) {
    this._programs.set(metadata.id, { metadata: metadata });
  }

  addProgramsMetadata(metadataList: ProgramMetadata[]) {
    for (const metadataItem of metadataList) {
      this.addProgramMetadata(metadataItem);
    }
  }

  get programs(): Map<number, ProgramType> {
    return this._programs;
  }

  updateProgramDetails(programIdNum, body) {
    // Map courses within each year to include proper status enum
    if (body.details.years) {
      body.details.years = body.details.years.map((yearData: any) => ({
        ...yearData,
        courses: yearData.courses.map((item: any) => ({
          ...item,
          status: CourseStatus.parseCourseStatus(item.status), // Converts to enum
        })),
      }));
    }

    // Handle unassigned courses if they exist
    if (body.details.unAssignCourses) {
      body.details.unAssignCourses = body.details.unAssignCourses.map(
        (item: any) => ({
          ...item,
          status: CourseStatus.parseCourseStatus(item.status),
        }),
      );
    }

    globalProgramStore.programs.set(programIdNum, body);
    globalProgramStore.currentId = programIdNum;

    // Add all courses to course store, including both assigned and unassigned
    const allCourses = [
      ...(body.details.unAssignCourses || []),
      ...(body.details.years || []).flatMap((year) => year.courses || []),
    ];
    globalCourseStore.addCourseMetadataList(allCourses);

    this._version++;
  }

  get version() {
    return this._version;
  }

  addProgramDetails(programId: number, programDetails: ProgramDetails) {
    if (this._programs.has(programId)) {
      this._programs.get(programId)!.details = programDetails;
    } else {
      throw new Error(`can't detect programId: ${programId}`);
    }
  }
}
const globalProgramStore = new ProgramStore();
export default globalProgramStore;
